import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * One conversation in full, oldest turn first.
 *
 * ## The id has to be encoded
 *
 * A thread id is `<iso>#<uuid>`, so it carries both `:` and `#`. Dropped into a
 * path unencoded, everything from the `#` is a URL fragment: the browser never
 * sends it, the server sees a truncated id, and the answer is an empty
 * transcript rather than an error. `encodeURIComponent` is what makes it one
 * path segment — and it has to be applied before the request is signed, so the
 * string aws4 signs is byte-for-byte the one axios puts on the wire.
 */
export const getNerobottiThread = async (threadId) => {
  const apiPath = `nerobotti/threads/${encodeURIComponent(threadId)}`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};

export default getNerobottiThread;
